import { useEffect } from 'react'
import { usePromise } from 'shared/hooks/usePromise'
import { rateApi } from './api'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext.tsx'

type Props = {
  fromCode?: string
  toCode?: string
}

const requestRate = async ({ fromCode, toCode, username }: Props & { username: string }) => {
  if (fromCode === toCode) {
    return '1'
  }

  if (!fromCode || !toCode) {
    return null
  }

  const response = await rateApi.getRate({ amount_from: '1', currency_from: fromCode, currency_to: toCode }, username)

  return response.data.amount_to
}

export const useRate = ({ fromCode, toCode }: Props) => {
  const { username } = useStreamerConfigContext()
  const { data: rate, isLoading, send } = usePromise(requestRate)

  useEffect(() => {
    username && send({ fromCode, toCode, username })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromCode, toCode, username])

  return {
    rate,
    isLoading,
  }
}
